<app-header></app-header>
<app-breadcrumb></app-breadcrumb>
<section class="experience-section section-gap section-gap-half">
  <div class="container">
    <div class="row">
      <div class="col-lg-5 col-md-8 wow fadeInLeft" data-wow-delay="0.3s">
        <div class="section-title with-right-border mb-md-gap-30">
          <div class="profile-sidebar">
            <div class="single-doctor-box">
              <div class="image">
                <img src="assets/img/about/doctor2.jpg" alt="doctor-image">
                <div class="icon">
                  <i class="flaticon-stethoscope"></i>
                </div>
              </div>
              <div class="content">
                <h3>{{ 'SevdaUgrasPage.SevdaUgrasTitle0' | translate }}</h3>
                <span class="designation">{{ 'SevdaUgrasPage.SevdaUgrasTitle5' | translate }}</span>
<!--                <p>{{ 'SevdaUgrasPage.SevdaUgrasShortDesc' | translate }}</p>-->
<!--                <ul class="social">
                  <li>
                    <a href="https://www.facebook.com/ProfDrAliAkinUgras" target="_blank">
                      <i class="flaticon-facebook-app-symbol"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/" target="_blank">
                      <i class="flaticon-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/" target="_blank">
                      <i class="flaticon-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/" target="_blank">
                      <i class="flaticon-instagram"></i>
                    </a>
                  </li>
                </ul>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 offset-lg-1 wow fadeInRight" data-wow-delay="0.3s">
        <div class="experience-text">
<!--          <h3 class="pb-3">{{ 'SevdaUgrasPage.SevdaUgrasTitle0' | translate }}</h3>-->

          <p class="fs-16 text-color-2 pb-3">{{ 'SevdaUgrasPage.SevdaUgrasText1' | translate }}</p>

          <p class="fs-16 text-color-2 pb-3"> {{ 'SevdaUgrasPage.SevdaUgrasText2' | translate }}</p>

        </div>
      </div>
    </div>

    <div class="row pt-5 mt-5">
      <div class="col-lg-12 col-md-12 wow fadeInLeft" data-wow-delay="0.3s" style="display:inline-flex;">

        <div class="col-lg-4 col-md-12">
          <h4 class="pb-3">{{ 'SevdaUgrasPage.SevdaUgrasTitle1' | translate }}</h4>
          <ul class="pb-3">
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText4' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText5' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText6' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText7' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText8' | translate }}
            </li>
          </ul>
        </div>

        <div class="col-lg-4 col-md-12">
          <h4 class="pb-3">{{ 'SevdaUgrasPage.SevdaUgrasTitle2' | translate }}</h4>
          <ul class="pb-3">
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText9' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText10' | translate }}
            </li>
          </ul>

          <h4 class="pb-3">{{ 'SevdaUgrasPage.SevdaUgrasTitle3' | translate }}</h4>
          <ul class="pb-3">
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText11' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText12' | translate }}
            </li>
          </ul>

        </div>

        <div class="col-lg-4 col-md-12">
          <h4 class="pb-3">{{ 'SevdaUgrasPage.SevdaUgrasTitle4' | translate }}</h4>
          <ul class="pb-3">
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText13' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText14' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText15' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText16' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText17' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText18' | translate }}
            </li>
            <li class="fs-16 text-color-2 pb-1" style="color:#81a3bb"><i class="fal fa-long-arrow-right"></i>&nbsp;&nbsp;&nbsp;{{ 'SevdaUgrasPage.SevdaUgrasText19' | translate }}
            </li>
          </ul>

        </div>
      </div>
    </div>

  </div>

</section>
<app-footer [layout]="classname" [logo]="ftlogo" [shape]="ftshape" [bgimage]="ftbgimage"></app-footer>
